import React from 'react';

import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import Layout from '../../containers/Layout';
import Table from '../../components/Table';

import convertObjectToArray from '../../helpers/convertObjectToArray';
import LenderService from '../../services/LenderService';
import { useServicerStore } from '../../store';

const cols = [
  {
    title: 'Name',
    keys: ['name'],
    link: (row) => `/lenders/${row.id}?tab=Lender`,
  },
  {
    title: 'Email',
    keys: ['email'],
    link: (row) => `/lenders/${row.id}?tab=Lender`,
  },
  {
    title: 'Phone',
    keys: ['phone'],
    link: (row) => `/lenders/${row.id}?tab=Lender`,
  },
  {
    title: 'Total loans',
    keys: ['_loan_count'],
    link: (row) => `/lenders/${row.id}?tab=Lender`,
  },
];

export default function LendersPage() {
  const { data: lenders, isFetching } = useQuery({
    queryKey: ['lenders'],
    queryFn: LenderService.getLenders,
  });

  const userRole = useServicerStore((state) => state.userRole);
  const isSuperAdmin = userRole === 'superAdmin';

  // Sometimes the backend is returning an object resembling an array, with numeric properties, rather than a conventional array. This fix is to ensure that the options are always an array.
  const validatedData = convertObjectToArray(lenders);

  return (
    <Layout>
      <div className="flex">
        {/* Content area */}
        <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
          <main className="grow">
            <div className="px-4 sm:px-6 lg:px-8 py-8 pb-10 w-full max-w-9xl mx-auto">
              {/* Page header */}
              <div className="sm:flex sm:justify-between sm:items-center mb-8">
                {/* Left: Title */}
                <div className="mb-4 sm:mb-0">
                  <h1 className="text-2xl md:text-3xl text-slate-800 dark:text-slate-100 font-bold">
                    Lenders
                  </h1>
                </div>

                {/* Right: Actions */}
                {isSuperAdmin && (
                  <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                    {/* Add lender button */}
                    <Link
                      to="/lenders/new?tab=Lender"
                      className="btn bg-indigo-500 hover:bg-indigo-600 text-white"
                    >
                      <svg
                        className="w-4 h-4 fill-current opacity-50 shrink-0"
                        viewBox="0 0 16 16"
                      >
                        <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                      </svg>
                      <span className="hidden xs:block ml-2">Add Lender</span>
                    </Link>
                  </div>
                )}
              </div>

              {/* Table */}
              <Table
                cols={cols}
                rows={validatedData}
                title="Lenders"
                isFetching={isFetching}
                minHeight={565}
              />
            </div>
          </main>
        </div>
      </div>
    </Layout>
  );
}
